import qwest from 'qwest';

export function getPerformanceFile() {
  return qwest.get('/performanceFile')
    .then((xhr, res) => res);
}
